import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f009712a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "d-flex secondary__color__text align-center" }
const _hoisted_3 = ["height"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0 0h24v24H0V0z",
  fill: "none"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M15 5v7H9V5h6m0-2H9c-1.1 0-2 .9-2 2v9h10V5c0-1.1-.9-2-2-2zm7 7h-3v3h3v-3zM5 10H2v3h3v-3zm15 5H4v6h2v-4h12v4h2v-6z" }, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "d-flex secondary__color__text align-center mx-1" }
const _hoisted_8 = ["height"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<g data-v-f009712a><rect fill=\"none\" height=\"24\" width=\"24\" data-v-f009712a></rect><rect fill=\"none\" height=\"24\" width=\"24\" data-v-f009712a></rect><rect fill=\"none\" height=\"24\" width=\"24\" data-v-f009712a></rect></g><g data-v-f009712a><g data-v-f009712a></g><g data-v-f009712a><path d=\"M12,14c1.66,0,3-1.34,3-3V5c0-1.66-1.34-3-3-3S9,3.34,9,5v6C9,12.66,10.34,14,12,14z\" data-v-f009712a></path><path d=\"M17,11c0,2.76-2.24,5-5,5s-5-2.24-5-5H5c0,3.53,2.61,6.43,6,6.92V21h2v-3.08c3.39-0.49,6-3.39,6-6.92H17z\" data-v-f009712a></path></g></g>", 2)
const _hoisted_11 = [
  _hoisted_9
]
const _hoisted_12 = {
  key: 0,
  class: "d-flex secondary__color__text align-center"
}
const _hoisted_13 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_14 = { class: "d-flex justify-center" }
const _hoisted_15 = { class: "text--center" }
const _hoisted_16 = { class: "text--center" }
const _hoisted_17 = { class: "text--center" }
const _hoisted_18 = { class: "text--center" }
const _hoisted_19 = { class: "text--center" }
const _hoisted_20 = { class: "text--center" }
const _hoisted_21 = { class: "text--center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_promotional_video = _resolveComponent("promotional-video")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.eventData)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "banner-home",
          style: _normalizeStyle({
        backgroundImage:
          'linear-gradient(0deg, rgba(0, 0, 0, 0.47), rgba(0, 0, 0, 0.47)),' +
          'url(' +
          _ctx.eventData.themeSettings.bannerURL +
          ')',
      })
        }, [
          _createElementVNode("div", {
            class: _normalizeClass({
          'container-home': _ctx.type === 'lg',
          'container-home-mobile text-center': _ctx.type != 'lg',
        })
          }, [
            _createElementVNode("h3", {
              class: _normalizeClass(["ma-0 secondary__color slider__date", { 'text-main-w': _ctx.type === 'lg' }])
            }, _toDisplayString(_ctx.formatDateStart(_ctx.eventData.startDate)), 3),
            _createElementVNode("h2", {
              class: _normalizeClass(["my-1 slider__event__name event-name-text", { 'text-main-w': _ctx.type === 'lg' }])
            }, _toDisplayString(_ctx.eventData.name), 3),
            _createElementVNode("div", {
              class: _normalizeClass(["d-flex flex-wrap", {
            'text-main-w': _ctx.type === 'lg',
            'justify-center': _ctx.type != 'lg',
          }])
            }, [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(), _createElementBlock("svg", {
                  style: {"fill":"var(--theme-secondary-color)"},
                  class: "",
                  xmlns: "http://www.w3.org/2000/svg",
                  height: _ctx.type != 'lg' ? '30px' : '45px',
                  viewBox: "0 0 24 24",
                  width: "45px",
                  fill: "#FFFFFF"
                }, _hoisted_6, 8, _hoisted_3)),
                _createElementVNode("span", {
                  class: _normalizeClass(["ml-1 expected__people white-text", { 'expected__people-mobile': _ctx.type != 'lg' }])
                }, _toDisplayString(_ctx.eventData.expectedPeople) + " " + _toDisplayString(_ctx.$t("home.seats")), 3)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock("svg", {
                  style: {"fill":"var(--theme-secondary-color)"},
                  xmlns: "http://www.w3.org/2000/svg",
                  "enable-background": "new 0 0 24 24",
                  height: _ctx.type != 'lg' ? '30px' : '45px',
                  viewBox: "0 0 24 24",
                  width: "45px",
                  fill: "#FFFFFF"
                }, _hoisted_11, 8, _hoisted_8)),
                _createElementVNode("span", {
                  class: _normalizeClass(["ml-1 expected__people", { 'expected__people-mobile': _ctx.type != 'lg' }])
                }, _toDisplayString(_ctx.$t("home.greatsSpeakers")), 3)
              ]),
              (_ctx.eventLocation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["material-icons secondary__color", { 'location-icon': _ctx.type === 'lg' }])
                    }, " location_on ", 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["ml-1 expected__people", { 'expected__people-mobile': _ctx.type != 'lg' }])
                    }, _toDisplayString(_ctx.eventLocation()), 3)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            (
            !_ctx.isLogged &&
            !_ctx.isEventEnded &&
            (_ctx.isOnlineRegisterActive || _ctx.optionalOnlineRegisterURL !== '')
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_el_button, {
                    class: "primary__color__button",
                    onClick: _ctx.goToRegister
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("drawer.register")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            style: _normalizeStyle(_ctx.getGradiantColor()),
            class: _normalizeClass(["counter-event py-1", { 'w-counter-event-mobile': _ctx.type != 'lg' }])
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t1': _ctx.type === 'lg',
                'counter-event-t1-mobile': _ctx.type != 'lg',
              }])
                }, _toDisplayString(("0" + _ctx.counter.days).slice(-_ctx.counter.days.length)), 3),
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t2': _ctx.type === 'lg',
                'counter-event-t2-mobile': _ctx.type != 'lg',
              }])
                }, _toDisplayString(_ctx.$t("home.time.days")), 3)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t1': _ctx.type === 'lg',
                'counter-event-t1-mobile': _ctx.type != 'lg',
              }])
                }, " : ", 2)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t1': _ctx.type === 'lg',
                'counter-event-t1-mobile': _ctx.type != 'lg',
              }])
                }, _toDisplayString(("0" + _ctx.counter.hours).slice(-2)), 3),
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t2': _ctx.type === 'lg',
                'counter-event-t2-mobile': _ctx.type != 'lg',
              }])
                }, _toDisplayString(_ctx.$t("home.time.hours")), 3)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t1': _ctx.type === 'lg',
                'counter-event-t1-mobile': _ctx.type != 'lg',
              }])
                }, " : ", 2)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t1': _ctx.type === 'lg',
                'counter-event-t1-mobile': _ctx.type != 'lg',
              }])
                }, _toDisplayString(("0" + _ctx.counter.minutes).slice(-2)), 3),
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t2': _ctx.type === 'lg',
                'counter-event-t2-mobile': _ctx.type != 'lg',
              }])
                }, _toDisplayString(_ctx.$t("home.time.minutes")), 3)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t1': _ctx.type === 'lg',
                'counter-event-t1-mobile': _ctx.type != 'lg',
              }])
                }, " : ", 2)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t1': _ctx.type === 'lg',
                'counter-event-t1-mobile': _ctx.type != 'lg',
              }])
                }, _toDisplayString(("0" + _ctx.counter.seconds).slice(-2)), 3),
                _createElementVNode("p", {
                  class: _normalizeClass(["ma-0", {
                'counter-event-t2': _ctx.type === 'lg',
                'counter-event-t2-mobile': _ctx.type != 'lg',
              }])
                }, _toDisplayString(_ctx.$t("home.time.seconds")), 3)
              ])
            ])
          ], 6)
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_promotional_video)
  ]))
}